import { useEffect, useState } from 'react';
import { APIURL } from "../../../configApi/apiConfig";
import axios from "../../../configApi/axiosConfig";

const parseConversation = (text) => {
	const messages = [];
	const regex = /(Agent|User):\s*(.*?)(?=(?:Agent|User):|$)/gs;
	let match;
	while ((match = regex.exec(text)) !== null) {
		messages.push({ role: match[1], text: match[2].trim() });
	}
	return messages;
};

export const HistorialCobranza = ({ idCompra, onClose }) => {

	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {

		const fetchHistorial = async () => {
			try {
				const response = await axios.get(APIURL.get_simplia_competencia(idCompra));
				const json = await response.data;
				setData(json);
			} catch (error) {
				console.error('Error al cargar historial:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchHistorial();
	}, [idCompra]);

	if (!idCompra) return null;

	const messages = data?.Transcript ? parseConversation(data.Transcript) : [];


	return (
		<div
			onClick={onClose}
			class="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] p-4"
		>
			<div
				onClick={e => e.stopPropagation()}
				class="bg-white rounded-xl w-full max-w-xl overflow-hidden max-h-[90vh] overflow-y-auto font-sans"
			>

				{/* header */}
				<div
					class="bg-[#2D3689] px-6 py-5 flex justify-between items-center"
				>
					<div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
						{[
							['Nombre', data?.Cliente],
							['Número', data?.Celular],
							['Cédula', data?.Cedula],
						].map(([label, val]) => (
							<div key={label}>
								<p
									class="text-white/60 text-[11px] tracking-wide uppercase m-0"
								>
									{label}</p>
								<p
									class="text-white text-sm font-medium m-0"
								>{loading ? '...' : val}</p>
							</div>
						))}
					</div>
					<button
						class="bg-white/15 text-white w-7 h-7 rounded-full text-base cursor-pointer border-none"
						onClick={onClose}>×</button>
				</div>

				{/* campos */}
				<div
					class="px-6 py-5 border-b border-gray-200"
				>
					<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
						{[
							['Compromiso', data?.Compromiso],
							['Categoría', data?.Categoria],
							['Motivo', data?.Motivo],
							['Sentimiento', data?.SentimientoPersona],
						].map(([label, val]) => (
							<div key={label}>
								<p
									class="text-gray-500 text-[11px] tracking-wide uppercase mb-[2px]"
								>{label}</p>
								<p
									class="text-gray-900 text-[13px] font-medium m-0"
								>{loading ? '...' : val}</p>
							</div>
						))}
					</div>
					<div style={{ marginTop: '12px' }}>
						<p
							class="text-gray-500 text-[11px] tracking-wide uppercase mb-[2px]"
						>Notas</p>
						<p
							class="text-gray-900 text-[13px] font-medium m-0"
						>{loading ? '...' : data?.Resumen}</p>
					</div>
				</div>

				{/* conversacion */}

				{messages.length > 0 && (
					<div style={{ padding: '0 1.5rem 1rem' }}>
						<p
							class="text-gray-500 text-[11px] tracking-wide uppercase mb-[2px]"
						>Conversación</p>
						<div
							class="bg-gray-50 border border-gray-200 rounded-lg p-3 h-[220px] overflow-y-auto flex flex-col gap-2"
						>
							{messages.map((msg, i) => (
								<div key={i} style={{ display: 'flex', justifyContent: msg.role === 'Agent' ? 'flex-start' : 'flex-end' }}>
									<div style={{ maxWidth: '72%' }}>
										<span style={{ fontSize: '10px', color: '#9ca3af', display: 'block', marginBottom: '2px', textAlign: msg.role === 'Agent' ? 'left' : 'right' }}>
											{msg.role === 'Agent' ? 'Agente' : 'Cliente'}
										</span>
										<div style={msg.role === 'Agent' ?
											agent
											:
											user
										}>{msg.text}</div>
									</div>
								</div>
							))}
						</div>
					</div>
				)}

				<div style={{ padding: '0.75rem 1.5rem 1.25rem', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
					<button
						class="bg-orange-500 text-white px-4 py-[7px] rounded-md text-[13px] font-medium"
						onClick={onClose}
					>Cerrar</button>
				</div>

			</div>
		</div>
	);
};

// estilos chat
const agent = { background: '#2D3689', color: '#fff', borderRadius: '0 10px 10px 10px', padding: '8px 12px', fontSize: '13px', lineHeight: '1.4' };
const user = { background: '#fff', border: '0.5px solid #e5e7eb', color: '#111827', borderRadius: '10px 0 10px 10px', padding: '8px 12px', fontSize: '13px', lineHeight: '1.4' };